module.exports = __webpack_public_path__ + "img/banner4-7.ad317951.png";